import React, {ReactNode, RefObject} from "react";
import { DataHelper } from "../Helpers/DataHelper";
import MultiFileBrowser from "../Components/MultiFileBrowser";
import { PreviewExportModel } from "../Models/PreviewExportModel";
import { PreviewExportMetadataModel } from "../Models/PreviewExportMetadataModel";
import { PreviewProcedureModel } from "../Models/PreviewProcedureModel";
import DataGrid from "../Components/DataGrid";
import { PreviewMeasurement } from "../Models/PreviewMeasurement";
import { DataGridRow, UploadDataHelper } from "../Helpers/SharedClasses";
import { InfoBox } from "../Components/InfoBox";
import { Progressbar } from "../Components/Progressbar";
import { ProgressModel } from "../Models/ProgressModel";
import { StudyModel } from "../Models/StudyModel";
import { ErrorWindow } from "../Components/ErrorWindow";
import { MeasurmentThumbnail } from "../Components/MeasurementThumbnail";
import { UserAccessModel } from "../Models/UserAccessModel";
import { CryptographyHelper } from "../Helpers/CryptographyHelper";
import { PreviewProcedureMetadataModel } from "../Models/PreviewProcedureMetadataModel";
import { InputItem } from "../Components/InputItem";
import { Graft } from "../Models/Trigger/TriggerClasses";
import SubwayMap from "../Models/Trigger/SubwayMap";
import { ProcedurePrivateFieldsModel } from "../Models/ProcedurePrivateFieldsModel";
import CardiacSubwayMap from "../Models/Trigger/CardiacSubwayMap";

export class UploadWindow extends React.Component<
  {  dataHelper: DataHelper, studySelected: StudyModel, user: UserAccessModel, closeClicked: () => void, refreshStudyRequested: ()=> void  },
  {
    progressText: string,
    dynamicNames: any,
    progressTextDetails: string,
    uploadStatus: string,
    previewReady: boolean,
    uploadPreview: PreviewExportModel,
    cachedData: File[],
    uploadLoaded: number,
    uploadTotal: number,
    status: string;
    uploadedData: number[],
    totalFiles: number, 
    fileProgress: number,
    initialUploadStatus: string,
    privateData: ProcedurePrivateFieldsModel[],
    progressMetadata: PreviewExportMetadataModel
  }
> {
  errorWindow:  RefObject<ErrorWindow>;
  infoBox: RefObject<InfoBox>;
  fileBrowserMulti: RefObject<MultiFileBrowser>;
  pwd: string;
  constructor(props: any) {
      super(props);
      this.errorWindow = React.createRef();
      this.infoBox = React.createRef();
      this.fileBrowserMulti = React.createRef();
      this.pwd = "";
    this.state = {
        dynamicNames: {
          patientId: "Patient id",
          anatomicalLocations: "Anatomical Locations",
          createdDate: "Date"
          
        },
        progressText: "",
        totalFiles: 0,
        fileProgress: 0,
        uploadStatus: "",
        initialUploadStatus: "",
        progressTextDetails: "",
        previewReady: false,
        privateData: [],
        uploadPreview:  {
          id: "",
          importLabel: "",
          importDate: Date() as any,
          filename: "",
          hospitalName: "",
          serialNumber: "",
          department: "",
          softwareVersion: "", 
          exportDate: Date() as any,
          procedures: [],
          studySelected: props.studySelected.id,
          confirmEmail: false,
          includePatientId: false,
          encryptionEnabled: false,
          includeDateTime: props.studySelected.allowFullDateOnly,
          includeGenderHeightWeightAge: false,
          referenceValues: []
        },
        
        cachedData: [],
        uploadLoaded:0,
        uploadTotal:0,
        status: "uploadReady",
        uploadedData:[],
        progressMetadata: {
          studyId:"",
          id: "",
          procedures: []
        }
    }
     this.cryptoHelper = new CryptographyHelper();
  }
  cryptoHelper: CryptographyHelper;
  intervalSet: any;
  startPingProcess = ()=>
  {
      this.intervalSet = setInterval(()=>{
        this.pingProgress((keepRunning: boolean) =>{
          if (!keepRunning)
          {
            console.log("Clearing Ping")
            clearInterval(this.intervalSet);
          }
           
        });
      }, 1000)

  }
  progressUpdatedOther = (arg0: ProgressEvent, progressMessage: string = "")=>
  {
  }
  progressUpdated = (arg0: ProgressEvent, progressMessage: string = "")=>
  {
    
    if (arg0)
    {
      this.setState({uploadLoaded: arg0.loaded, uploadTotal: arg0.total});
    if (arg0.loaded === arg0.total)
    {
      if (progressMessage !== "Process")
      {
      
          this.startPingProcess();
          this.setState({
            uploadStatus: "",
            progressText: "Upload finishing up. Starting processing..." 
          });
      }else
      {
        //This means you can close the browser.
        this.setState({
          uploadStatus: "Processing",
          progressText: "Processing started." 
        });
      }
    
    }else
    
    {
      if (progressMessage !== "Process")
      {
      this.setState({
        uploadStatus: "Uploading",
        progressText: "Upload progress: " + (arg0.loaded/1000000).toFixed(2)  +" MB/"+ (arg0.total/1000000).toFixed(2)  +" MB"
      });
    }else
    {
      this.setState({
        uploadStatus: "Preparing",
        progressText: "Preparing measurements"
      });
    }
    }
  }
  else
  {
  let progressErrorsDetails = progressMessage.split("#");
  this.setState({
    uploadStatus: "",
    progressText: progressErrorsDetails[0],
    progressTextDetails: progressErrorsDetails.length > 1 ? progressErrorsDetails[1] : ""
  });
  }
      
  }

  processXmlFile = async (fileIn: File, otherFiles: File[], proceduresAll: PreviewProcedureMetadataModel[], proceduresAllFull: PreviewProcedureModel[]): Promise<PreviewExportModel> =>
  {
    let xmlContent = await fileIn.text();
    let uploadDataHelper = new UploadDataHelper();

    let parsedImportDetails = uploadDataHelper.parseFullXmlFile(this.props.studySelected?.id as string, this.props.dataHelper.user_id, this.props.user.userHospital, this.props.user.userType,  this.props.studySelected.allowFullDateOnly as boolean, xmlContent, otherFiles, proceduresAll, proceduresAllFull);
    let previewModel = parsedImportDetails.previewModel;
    let privateProcs = parsedImportDetails.procedures;
    let metadataModel = parsedImportDetails.metadata;

    previewModel.filename = fileIn.name;
    this.props.dataHelper.CallStudyService("ConfirmStudyData", metadataModel, null, (item: any)=>
    {
      let progModel: PreviewExportMetadataModel = JSON.parse(item);
      let previewMain = this.state.uploadPreview;

      for (let index = 0; index < previewMain.procedures.length; index++) {
        if (progModel.procedures[index] && previewMain.procedures[index])
        {
        previewMain.procedures[index].existing = progModel.procedures[index].existing ;
        previewMain.procedures[index].selected = !progModel.procedures[index].existing ;
      
          for (let index2 = 0; index2 < previewMain.procedures[index].measurements.length; index2++) {
            if (progModel.procedures[index].measurements[index2] && previewMain.procedures[index].measurements[index2])
            {
                previewMain.procedures[index].measurements[index2].existing = progModel.procedures[index].measurements[index2].existing ; 
                previewMain.procedures[index].measurements[index2].selected = !progModel.procedures[index].measurements[index2].existing ;
            }
          }
        }
      }
      this.setState({
        uploadPreview: previewMain,
        privateData: privateProcs
        //progressMetadata: progModel
       });


    }, ()=>{}, "POST");
    return previewModel;
  }

  onUploadConfirmed = async (dataOut: File[]) =>
  {

    let proceduresTotal: PreviewProcedureMetadataModel[] = [];
    let proceduresTotalFull: PreviewProcedureModel[] = [];
    for (let index = 0; index < dataOut.length; index++) {
      const element = dataOut[index];
      if (element.name &&  element.name.endsWith(".xml"))
      {
         let previewModel = await this.processXmlFile(element, dataOut, proceduresTotal, proceduresTotalFull);
         
         

         this.setState({
          uploadPreview: previewModel,
          cachedData: dataOut,
          previewReady: true,
      
         });
        
      }
      
    }

    // let uploadData: PreviewExportModel = JSON.parse(dataOut);
    //   this.setState({
    //     previewReady: true,
    //     uploadPreview: uploadData
    //   })
  }


  fileQueue: any = {};
  fileProcedureLookup: any = {};
  failedFiles: any = {};
  totalFiles: number = 0;
  filesUploaded: any = {};
  fileProgress: number = 0;
  totalSize: number = 0;
  currentIndex: number = 0;
  concurrentRequests: number = 0;
  uploadXmlNotStarted: boolean = true;
  maxConcurrentRequests: number = 5;
  labelToUse: string = "";
  mainFormData: any = {};
  callUploadsInterval: any = {};
  finalCallback: Function = ()=>{};

  runDataCorrection = async (filenameIn: string, dataOut: any)=>
  {
    for (let index2 = 0; index2 < this.state.uploadPreview.procedures.length; index2++) {
              const procelement = this.state.uploadPreview.procedures[index2];
              
              if (procelement.selected)
              {
                if (!this.state.uploadPreview.includePatientId)
                  procelement.patientId = "";
                else if (this.props.studySelected.encryptionEnabled && this.state.uploadPreview.encryptionEnabled)
                {
                  //Lets try encrypt this here.
                 
                  let msgOutOV = await this.cryptoHelper.encryptValue(procelement.overrideId as string, this.pwd);
                  procelement.overrideId = msgOutOV;
                  let msgOut = await this.cryptoHelper.encryptValue(procelement.patientId as string, this.pwd);
                  procelement.patientId = msgOut;
              }
                if (!this.state.uploadPreview.includeGenderHeightWeightAge)
                {
                  procelement.height = 0;
                  procelement.weight = 0;
                  procelement.birthYear = 0;
                  procelement.gender = 0;
                }
                if (!this.props.studySelected.calculateBMI)
                  {
                    procelement.bmi = 0;
                  }

                if (!this.props.studySelected.includeSurgeon)
                {
                  procelement.surgeon = "";
                }
                if (!this.props.studySelected.includeProject)
                {
                  procelement.projects = "";
                }

                if (!this.state.uploadPreview.includeDateTime)
                  {
                    procelement.createdDate?.setDate(1);
                    procelement.createdDate?.setHours(12);
                    procelement.createdDate?.setMinutes(0);
                    procelement.createdDate?.setSeconds(0);
                  }
                  for (let index3 = 0; index3 < procelement.measurements.length; index3++) {
                    const measurementelement = procelement.measurements[index3];
                    if (filenameIn.indexOf(measurementelement.id) === 0 && measurementelement.selected)
                      measurementelement.fileUrl = dataOut;

                      if (!this.state.uploadPreview.includeDateTime)
                      {
                        measurementelement.recordDate?.setDate(1);
                        measurementelement.recordDate?.setHours(12);
                        measurementelement.recordDate?.setMinutes(0);
                        measurementelement.recordDate?.setSeconds(0);
                      }

                  }
              }
            }
  }

  checkUploads = async ()=>{
    let DataRec = this.props.dataHelper;

    if (Object.keys(this.fileQueue).length === 0)
    {
        await this.runDataCorrection("", null);
    }

    while (this.concurrentRequests < this.maxConcurrentRequests && this.uploadXmlNotStarted && this.currentIndex < Object.keys(this.fileQueue).length)
    {
      
      try {
      
      console.log("Concurrent requests: " + this.concurrentRequests);
      console.log("Queue length: " + Object.keys(this.fileQueue).length);
      console.log("Current index: " + this.currentIndex);
      if (this.currentIndex === 1297)
      {
        console.log("Current index: " + this.currentIndex);
      }

      
      if (this.currentIndex < Object.keys(this.fileQueue).length)
      {
      //There are still files to upload.
        this.concurrentRequests++;
      let filenameIn = Object.keys(this.fileQueue)[this.currentIndex];
      this.currentIndex++;
      const element = this.fileQueue[filenameIn];
      
      console.log("File size: " +(element as File).size);
      console.log("File code: " +(element as File).name);



        let singleformData = new FormData();
        singleformData.append('files', element);
        singleformData.append('studySelected', this.props.studySelected?.id as string);
        singleformData.append('importLabel', this.labelToUse);

        this.updateProcedureProgress(this.fileProcedureLookup[filenameIn], 1, 0);

        DataRec.CallDataServiceFiles("StudyUpload", "SingleFileUpload", singleformData, async (dataOut: any)=>
        {

            this.concurrentRequests--;
            this.filesUploaded[filenameIn] = dataOut;
            await this.runDataCorrection(filenameIn, dataOut);
           
            this.updateProcedureProgress(this.fileProcedureLookup[filenameIn], 2, 0);

            this.fileProgress = this.fileProgress + element.size;
            this.setState({
              uploadStatus: "Uploading",
              progressText: "",
              initialUploadStatus: this.fileProgress === this.totalSize ? "Initial Upload Complete" : "File upload progress: " + ( this.fileProgress/1000000).toFixed(2)  +" MB/"+ (this.totalSize/1000000).toFixed(2)  +" MB",
              fileProgress: Object.keys(this.filesUploaded).length,
              totalFiles: this.totalFiles
            });
           
            //this.uploadXmlFile(DataRec);
            // console.log("Files Uploaded successfully");
            // callback(dataOut);
            //this.props.onUploadComplete(dataOut);
        }, (status: number, errorText: string, statusText: string) =>{ 
          //If a file fails on upload lets give up straight away and expect 1 less file?
         
          this.totalFiles--; 

          this.failedFiles[element.name.toLowerCase()] = element;
          this.concurrentRequests--;
          if (this.errorWindow.current  as ErrorWindow)
            (this.errorWindow.current  as ErrorWindow).show(status, "An upload of a file failed. This can be closed and the upload will continue... \n" + errorText, statusText, "File upload failed")
        }, this.progressUpdatedOther, false);
      
    }else{
      //At this point all files have started to upload. We Just need to wait for the them to all complete. 

      if (this.concurrentRequests === 0)
      {
        if (this.uploadXmlNotStarted)
        {
          if (this.uploadXmlFile(DataRec))
          {
            clearInterval(this.callUploadsInterval);
          }
      }
      }
    }
      
  } catch (error) {
    this.concurrentRequests--;
  }
  }
  if (this.currentIndex >= Object.keys(this.fileQueue).length)
   {
      if (this.concurrentRequests === 0)
        {
          if (this.uploadXmlNotStarted)
          {
            if (this.uploadXmlFile(DataRec))
            {
              clearInterval(this.callUploadsInterval);
            }
        }
    }
  }

  }

  markUploadingCompleted = (dataOut: any, justStopTimer = false)=>
  {
    console.log("Clearing Ping");
    clearInterval(this.intervalSet);
    if (!justStopTimer)
    {
      this.setState({
        uploadStatus: "Completed"
      });
  
      console.log("Files Uploaded successfully");
      this.finalCallback(dataOut);
    }
    
  }

  uploadXmlFile = (DataRec: DataHelper) =>
  {
    this.uploadXmlNotStarted = false;
    // if (Object.keys(this.filesUploaded).length === this.totalFiles)
    //   {
        if (Object.keys(this.failedFiles).length > 0)
        {
          //If there are failed files we could try reupload them here?
          if (this.infoBox.current  as InfoBox)
          (this.infoBox.current  as InfoBox).show(Object.keys(this.failedFiles).length + " files failed during upload. These can be uploaded later. "  );
          console.log("Upload failed files: " + JSON.stringify(Object.keys(this.failedFiles)));
        }
       

        //Once all files are done we can set to 0 so we don't try upload again.
        // this.totalFiles = -1;

        // clearInterval(this.callUploadsInterval);
        //Now we are ready to do the final upload
        //This is a little weird. Still torn to as to whether we should use the hear instead?
          let uploadPreview = this.state.uploadPreview;
          uploadPreview.studySelected = this.props.studySelected.id as string;
          uploadPreview.importLabel = this.labelToUse;

          //First we need to remove all procedures that are not selected.
          let copyOfUploadPreview = uploadPreview;
          var filtered = copyOfUploadPreview.procedures.filter(function(value, index, arr){ 
            return value.selected;
        });
        //we also need to filter out measurements that are not selected.
        for (let index = 0; index < copyOfUploadPreview.procedures.length; index++) {
            const element = copyOfUploadPreview.procedures[index];
            let filteredMeasurements = element.measurements.filter(function(value, index, arr){ 
              return value.selected;
            });
            element.measurements = filteredMeasurements;
        }
          
        copyOfUploadPreview.procedures = filtered;

          this.mainFormData.append("previewexport", JSON.stringify(copyOfUploadPreview));
         
        DataRec.CallDataServiceFiles("StudyUpload", "FileUpload", this.mainFormData, (dataOut: any )=>
        {
            this.markUploadingCompleted(dataOut);
           
            //this.props.onUploadComplete(dataOut);
        }, (status: number, errorText: string, statusText: string) =>{ 
          this.markUploadingCompleted(null, true);
          if (status === 500)
          {
            //A 500 error indicates that something went wrong where as anything else may still succeeed so donæt show an error just log it.
            if (this.errorWindow.current  as ErrorWindow)
              (this.errorWindow.current  as ErrorWindow).show(status, errorText, statusText, "File upload failed")
          }else
          {
            console.log("FileUpload failed: " + status +" - " + errorText + " - " + statusText );
          }
        }, this.progressUpdated, false);

        return true;
      // }
      // return false;

  }

  uploadFiles = async (e: any, callback: Function) =>
      {
        this.uploadXmlNotStarted = true;
        this.totalFiles = 0;
        this.totalSize = 0;
        this.fileProgress = 0;
        this.fileQueue = {};
        this.fileProcedureLookup = {};
        this.filesUploaded = {};
        this.setState({
          uploadStatus: "Confirming",
          progressText: "",
          initialUploadStatus: "Preparing raw data files...",
          totalFiles: 1
        });
        let labelToUse = "OTHER";
        if (this.state.uploadPreview.importLabel)
        {
          labelToUse = this.state.uploadPreview.importLabel;
        }
        let formData = new FormData();

        // let pwd = this.props.dataHelper.getPwd(true);
        // for (let index2 = 0; index2 < this.state.uploadPreview.procedures.length; index2++) {
        //   const procelement = this.state.uploadPreview.procedures[index2];
          
        //   if (procelement.selected)
        //   {
        //     if (!this.state.uploadPreview.includePatientId){
        //     procelement.patientId = "";
        //     }
            
        //     else if (this.props.studySelected.encryptionEnabled)
        //     {
        //       //Lets try encrypt this here.
        //       let enc = new CryptographyHelper();
           
        //       let msgOut = await enc.encryptValue(procelement.patientId as string, pwd);
        //       procelement.patientId = msgOut;
              
        //     }
        //   }
        // }

        if (this.props.studySelected.encryptionEnabled && this.state.uploadPreview.encryptionEnabled)
        {
          this.pwd = this.props.dataHelper.getPwd(true);
        }
       
              for (let index = 0; index < this.state.cachedData.length; index++) {
                  const element = this.state.cachedData[index];
                  let isSelected = element.name.toLowerCase().endsWith(".xml");
                  let procId = "";
                  for (let index2 = 0; index2 < this.state.uploadPreview.procedures.length; index2++) {
                    const procelement = this.state.uploadPreview.procedures[index2];
                      procId = procelement.id;

                        for (let index3 = 0; index3 < procelement.measurements.length; index3++) {
                          const measurementelement = procelement.measurements[index3];
                          if (element.name.indexOf(measurementelement.id) === 0 && measurementelement.selected)
                            isSelected = true;
                        }
                    
                      }
                  if (isSelected && !element.name.toLowerCase().endsWith(".xml"))
                  {
                    this.totalFiles++;
                    this.fileQueue[element.name.toLowerCase()] = element;
                    this.fileProcedureLookup[element.name.toLowerCase()] = procId;
                    this.totalSize += element.size;
                  
                  }else if (element.name.toLowerCase().endsWith(".xml"))
                  {
                    //TODO: We no longer upload the XML file to avoid privacy issue.
                    //formData.append('files', element);
                  }
                   
              }
              this.setState({
                uploadStatus: "Uploading",
                progressText: "",
                initialUploadStatus: "Initializing upload...",
                totalFiles: 1
              });

              this.currentIndex = 0;
              this.labelToUse =labelToUse;
              this.mainFormData = formData;
              this.finalCallback = callback;
              this.callUploadsInterval = setInterval(this.checkUploads, 1000);

              // for (let index = 0; index < Object.keys(this.fileQueue).length; index++) {
                
               
               
              // } 
      }

      updateProcedureProgress = (procId: string, uploaded: number, processed: number) : void =>
        {
          let uploadProcs = this.state.progressMetadata;
          let ischanged = false;
            for (let index = 0; index < uploadProcs.procedures.length; index++) {
            if (procId=== uploadProcs.procedures[index].id)
              {
                if (uploadProcs.procedures[index].processed  !== processed)
                  {
                    ischanged = true;
                    uploadProcs.procedures[index].processed = processed;
                  }
           //Uploading moves up. (It's updated per measurement.)
                if (uploadProcs.procedures[index].uploaded  < uploaded)
                  {
                    ischanged = true;
                    uploadProcs.procedures[index].uploaded = uploaded;
                  }
               
              }
            }
      if ( ischanged)
        {
          this.setState({
            progressMetadata: uploadProcs
          });
        //  this.forceUpdate();
        }
           
        }

      pingProgress = (clearTimerFunction: Function) : void =>
      {
        if (this.state.uploadStatus === "Completed")
          return;
          this.props.dataHelper.CallService("StudyUpload", "PingProgress", {}, { instructionId: this.props.dataHelper.user_id}, (item: string)=>{

            if (this.state.uploadStatus === "Completed")
              return;

          let progModel: ProgressModel = JSON.parse(item);
          let uploadProcs = this.state.progressMetadata;
          
            if (progModel.progressMetadata)
            {
            let allprocs = uploadProcs.procedures.length;
            let completedprocs = 0;
          

              
              for (let index = 0; index < allprocs; index++) {
                for (let index1 = 0; index1 < progModel.progressMetadata.procedures.length; index1++) {
              if (progModel.progressMetadata.procedures[index1].id === uploadProcs.procedures[index].id)
                {
                  uploadProcs.procedures[index].processed = progModel.progressMetadata.procedures[index1].processed;
                  uploadProcs.procedures[index].uploaded = progModel.progressMetadata.procedures[index1].uploaded;
                }
              }
                if (uploadProcs.procedures[index].uploaded === 3 && uploadProcs.procedures[index].processed  === 3)
                  {
                    completedprocs++;
                  }
            }
            
            //Don't stop pinging when all files are uploaded. Need to keep pinging till they are all processed.  
            if (completedprocs > 0 && allprocs > 0)
              clearTimerFunction(completedprocs !== allprocs);
          }
          this.setState({
            // uploadStatus: "",
            // progressText: "Processing completed." , 
            progressMetadata: uploadProcs
          });

            this.progressUpdated({
              loaded: progModel.current, total:  progModel.total
            } as any, "Process");

           
          }, ()=>
          {

          }, "GET", false);
      }

      renderKeyValueInGrid = (item: any) =>
      {
          if (item as number)
          {
            return <div>{(item as number).toFixed(2)}</div>
          }else
          {
              return <div>--</div>
          }
      }

      //Put these in a helper class somewhere common to avoid redefinition.
      renderMeanValueInGrid = (item: any) =>
      {
          if (item as number)
          {
            return <div>{(item as number * 1000).toFixed(2)}</div>
          }else
          {
              return <div>--</div>
          }
      }
      renderListInGrid = (items: string[]) =>
      {
        let valToShow = "";
          for (let index = 0; index < items.length; index++) {
            const element = items[index];
            valToShow += element;
            if  (index < items.length-1)
              valToShow +=" - ";
          }
          return <div className="data-grid-cell">{valToShow}</div>;
      }

      renderSubwayMap = (itemValue: any, rowItem: any, parentItem: any): ReactNode =>
      {
          if (rowItem as PreviewMeasurement)
          {
            if ((rowItem as PreviewMeasurement).isIntui)
            {
              return this.renderIntuiGraft((rowItem as PreviewMeasurement).intuiGraft as Graft);
            }else
            {
              return this.renderListInGrid(itemValue);
            }
          }
      }

       renderIntuiGraft = (item: Graft) =>
      {
        if (item)
        {

          let subwayMap = (this.props.studySelected.studyType === "Cardiac" ?
                            <CardiacSubwayMap parentProcedure={null as any} protocolSteps={[]} showeditbutton={false}  CurrentItem={item}  showSelected={true} showsaves={false}></CardiacSubwayMap>
                            :
                            <SubwayMap CurrentItem={item} Context={"TTFM"} customGraftText={""} index={0} commentToggled={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } measurementSelectionOpen={false} measurementSelectionSelected={function (e: boolean): void {
                                throw new Error("Function not implemented.");
                            } } tileColorOn={false} ></SubwayMap>);
                          return <div className="data-grid-cell">{subwayMap}</div>;
        }
         else
                    return <></>;
         
                   
      }


      getSelectedProcedures = (exportModel: PreviewExportModel): PreviewProcedureModel[] => 
      {
        return exportModel.procedures.filter((procedure) => procedure.selected === true);
      }

      getSelectedMeasurements= (procedureModel: PreviewProcedureModel): PreviewMeasurement[] => 
      {
        return procedureModel.measurements.filter((measurement) => measurement.selected === true);
      }

      createRow(name: string, caption: string, renderTemplate: string) {
        return {
          Name: name,
          Caption: caption,
          RenderTemplate: renderTemplate
        };
      }
     

  render() {

    
    let dataMissing = false;
    if (this.state.uploadPreview.procedures && this.state.uploadPreview.procedures.length > 0)
    {
      for (let index = 0; index < this.state.uploadPreview.procedures.length; index++) {
        const procelement = this.state.uploadPreview.procedures[index];
        for (let index2 = 0; index2 < procelement.measurements.length; index2++) {
          const measelement = procelement.measurements[index2];
          if (measelement.missingData)
            dataMissing = true;
        }
      }
    }

    return (
        <>
      <MultiFileBrowser ref={this.fileBrowserMulti} performUpload={false} controllerName="StudyUpload" methodName={"FileUpload"} dataTransfer={this.props.dataHelper} progressEvent={this.progressUpdated} onUploadComplete={this.onUploadConfirmed} onUploadFailed={(status: number, errorText: string, statusText: string) =>{ 
              if (this.errorWindow.current  as ErrorWindow)
                (this.errorWindow.current  as ErrorWindow).show(status, errorText, statusText, "File upload failed")
            }}></MultiFileBrowser>
        {(this.state.status ==="uploadReady") ?       
        <><div id="uploadDataHere" className="uploadData"><div><div> <svg xmlns="http://www.w3.org/2000/svg" width="32" height="29" viewBox="0 0 80 72">
        <g id="Group_11270" data-name="Group 11270" transform="translate(0 -4)">
        <path id="Path_11899" data-name="Path 11899" d="M37.656,12.815a9.37,9.37,0,0,1,16.235,0L84.528,66.2A9.309,9.309,0,0,1,76.41,80.125H15.137A9.309,9.309,0,0,1,7.019,66.2Z" transform="translate(-5.773 -4.125)" fill="#f5db00"/>
        <path id="Union_100" data-name="Union 100" d="M5163-3972a5,5,0,0,1,5-5,5.136,5.136,0,0,1,3.957,1.945A4.762,4.762,0,0,1,5173-3972a5,5,0,0,1-5,5A5,5,0,0,1,5163-3972Zm0-17v-18a5,5,0,0,1,5-5,5,5,0,0,1,5,5v18a5,5,0,0,1-5,5A5,5,0,0,1,5163-3989Z" transform="translate(-5128 4034)"/>
        </g>
    </svg></div><div>Make sure to select all files (all *.xml and *.dat files) when uploading!</div></div></div>
        <div>{this.state.progressText}{this.state.progressTextDetails ? <span className="error-tooltip">{this.state.progressTextDetails}</span> : null}</div></>
        :<></>}   
        
        
          {(this.state.previewReady && (this.state.status==="uploadClicked" || this.state.status === "confirmClicked"))
          ?
          <div className="caseUploadWrapper">
            <div className="caseUploadForm">
              <div className="uploadBox uploadFormLeft">
                    <InputItem type="text" title={"Hospital Name:"} name={"hospitalName"} onChange={(name: string, value: string)=>
                    {if (this.props.user.userType!=="Uploader"){
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      copyOfUploadPreview.hospitalName = value
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }}} value={this.state.uploadPreview.hospitalName}></InputItem>
                <label><span>Department:</span> <em>{this.state.uploadPreview.department}</em></label>
                <label><span>Serial Number:</span> <em>{this.state.uploadPreview.serialNumber}</em></label>
                <label><span>Exported:</span> <em>{this.state.uploadPreview.exportDate?.toLocaleString()}</em></label>
                <label><span>Total procedures:</span> <em>{this.state.uploadPreview.procedures.length}</em></label>
                
              </div>

              <div className="uploadBox uploadFormCenter">
                  {/* <label>
                      <span>Import label:</span>
                      <input type="text" value={this.state.uploadPreview.importLabel} onChange={(e)=>
                  {
                    let copyOfUploadPreview = {...this.state.uploadPreview};
                    copyOfUploadPreview.importLabel = e.currentTarget.value
                    this.setState({
                        uploadPreview: copyOfUploadPreview
                      });
                  }}/>
                  </label> */}
 {
                      !this.props.studySelected.allowPersonalData || this.state.status==="confirmClicked"
                      ?
                      <></>
                      :
                  <label>
                    <span>Include patient id</span>
                      <input type="checkbox" checked={this.state.uploadPreview.includePatientId} onChange={(e)=>
                    {
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      
                      copyOfUploadPreview.includePatientId = e.currentTarget.checked;
                      if (copyOfUploadPreview.includePatientId)
                        copyOfUploadPreview.encryptionEnabled = true;
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }}
                 
                    />
                  </label>
                }
                  {this.props.studySelected.encryptionEnabled && this.state.uploadPreview.includePatientId &&(
                    <label>
                      <span>Use personal pin to encrypt data</span>
                        <input type="checkbox" checked={this.state.uploadPreview.encryptionEnabled} onChange={(e)=>
                    {
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      copyOfUploadPreview.encryptionEnabled = e.currentTarget.checked;
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }}/>
                    </label>
                  )}
                    {
                      !this.props.studySelected.allowPersonalData || this.state.status==="confirmClicked"
                      ?
                      <></>
                      :
                  <label>
                    <span>Include full date</span>
                      <input type="checkbox" checked={this.state.uploadPreview.includeDateTime} onChange={(e)=>
                    {
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      copyOfUploadPreview.includeDateTime = e.currentTarget.checked
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }}
                  
                    />
                  </label>
                    }
                    {
                      !this.props.studySelected.allowPersonalData || this.state.status==="confirmClicked"
                      ?
                      <></>
                      :
                      <label>
                    <span>Include height, weight, gender and year of birth</span>
                      <input type="checkbox" checked={this.state.uploadPreview.includeGenderHeightWeightAge} onChange={(e)=>
                    {
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      copyOfUploadPreview.includeGenderHeightWeightAge = e.currentTarget.checked
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }}
                    />
                  </label>
                    }
                  
                  <label>
                    <span>Send confirmation email when upload is complete</span>
                      <input type="checkbox" checked={this.state.uploadPreview.confirmEmail} onChange={(e)=>
                    {
                      let copyOfUploadPreview = {...this.state.uploadPreview};
                      copyOfUploadPreview.confirmEmail = e.currentTarget.checked
                      this.setState({
                          uploadPreview: copyOfUploadPreview
                        });
                    }} disabled={this.state.status==="confirmClicked"}/>
                  </label>

              </div>
              <div className="uploadBox uploadFormRight">
              {
          (this.state.status==="confirmClicked" ) ?  
          
            ((this.state.uploadStatus ==="Completed")? 
            <div className="innerBox uploadCompleted">
              <div className="gg-check"></div>
              <div className="textCompleted"> Successfully uploaded  {this.state.uploadedData[0]} procedures and {this.state.uploadedData[1]} measurements.</div>
            </div> :
            (this.state.uploadStatus ==="Processing")? 
          <div className="innerBox canClose">
          <div>You can now close this window. When processing is completed you will receive an email if that option was selected.</div> 
     </div>  
     :<div className="innerBox doNotClose">
     <h3>Do not close this browser window until the files have been uploaded and prepared for processing.</h3>
   </div>
    )
          
          
          :
          <div className="innerBox normalBox">
                   <h3>Instructions </h3> 
                   <p>Select procedures and measurements to upload in the table below.</p>
                   <p>Click UPLOAD when ready.</p> 
                   {
                    dataMissing ? <div><div> <svg xmlns="http://www.w3.org/2000/svg" width="32" height="29" viewBox="0 0 80 72">
                    <g id="Group_11270" data-name="Group 11270" transform="translate(0 -4)">
                    <path id="Path_11899" data-name="Path 11899" d="M37.656,12.815a9.37,9.37,0,0,1,16.235,0L84.528,66.2A9.309,9.309,0,0,1,76.41,80.125H15.137A9.309,9.309,0,0,1,7.019,66.2Z" transform="translate(-5.773 -4.125)" fill="#f5db00"/>
                    <path id="Union_100" data-name="Union 100" d="M5163-3972a5,5,0,0,1,5-5,5.136,5.136,0,0,1,3.957,1.945A4.762,4.762,0,0,1,5173-3972a5,5,0,0,1-5,5A5,5,0,0,1,5163-3972Zm0-17v-18a5,5,0,0,1,5-5,5,5,0,0,1,5,5v18a5,5,0,0,1-5,5A5,5,0,0,1,5163-3989Z" transform="translate(-5128 4034)"/>
                    </g>
                </svg></div><div>Not all data files were selected. Make sure to select all files when uploading!</div></div> : <></>
                   }
              </div>
        }

      
              </div>
          </div>

          <div id="proceduresGrid" className="proceduresGrid">
            <h2>Procedures</h2>
            {this.state.status==="confirmClicked" ?   
             <DataGrid columns={[ {Name: "selected", Caption: "Selected", SummaryTemplate: ()=>{ return <></>},
             RenderTemplate: (value: boolean, rowItem, parentRow) => {
   
               return <div className="primaryColumnChild">
                 <div className="caseNumberUpload">
                   {rowItem.index +1}
                 </div>

                 {
                   rowItem.existing ?
                   <div className="columnChildNote">Previously uploaded</div>
                   :<></>
                 }
                 </div>

                 }
             },
             {Name: "uploaded", Caption: "Uploaded", Type: "uploadstatus"},
             {Name: "processed", Caption: "Processed", Type: "uploadstatus"},
             {Name: "status", Caption: ""},
             ]} rows={this.state.progressMetadata.procedures}></DataGrid>
            :
            <DataGrid context="Upload" studySelected={this.props.studySelected} onChange={(rowdata: DataGridRow, columnChanged:string, value: any, index: number | undefined, submitToServer: boolean| undefined) =>{
             
             
              if (this.state.uploadPreview && this.state.uploadPreview.procedures && index as number >= 0 && index as number < this.state.uploadPreview.procedures.length)
              { 
                
            //For upload it is either overriding the Id or it is selecting the row. Nothing else.
                if (columnChanged === "overrideId")
             {
                    //eslint-disable-next-line
                   this.state.uploadPreview.procedures[index as number].overrideId= value;
             }else
             {
                //eslint-disable-next-line  
                this.state.uploadPreview.procedures[index as number].selected = value as boolean; 
                  
                  for (let lc = 0; lc < this.state.uploadPreview.procedures[index as number].measurements.length; lc++) {
                    const element = this.state.uploadPreview.procedures[index as number].measurements[lc];
                 
                
                    //eslint-disable-next-line
                    element.selected = value as boolean;
             }
                  
                }
              }
            
                this.forceUpdate();
            }} 
            onChildChange={(rowdata: DataGridRow,parentrowdata: DataGridRow, columnChanged:string, value: any, index: number | undefined, parentIndex: number | undefined, submitToServer: boolean| undefined) =>{
              
              if (this.state.uploadPreview && this.state.uploadPreview.procedures && parentIndex as number >= 0 && parentIndex as number < this.state.uploadPreview.procedures.length)
              {
                if (this.state.uploadPreview && this.state.uploadPreview.procedures && parentIndex as number >= 0 && parentIndex as number < this.state.uploadPreview.procedures.length){
                  if ((parentrowdata as PreviewProcedureModel).selected === false && (value as boolean)=== true) {
                      //this should disable the checkboxes of measurements when you uncheck a procedure
                  }
                  else{
                    // eslint-disable-next-line
                    this.state.uploadPreview.procedures[parentIndex as number].measurements[index as number].selected = value as boolean; 

                  }  
                }
                
                
              }
                  
                this.forceUpdate();
            }}
            
            columns={[
                  {Name: "selected", Caption: "Selected", Type:"boolean", Editable: true,
                  RenderTemplate: (value: boolean, rowItem, parentRow) => {
                    let type = "checkbox";
        
                    return <div className="primaryColumnChild">
                      
                      <label><input  type={type} checked={value}
                        onChange={(e)=>
                          {
                           
                            rowItem["selected"] = (e.target as HTMLInputElement).checked;
                            let valueIn = rowItem["selected"];
                                if (this.state.uploadPreview && this.state.uploadPreview.procedures && rowItem.index  as number >= 0 && rowItem.index as number < this.state.uploadPreview.procedures.length)
                                { 
                                  //eslint-disable-next-line  
                                  this.state.uploadPreview.procedures[rowItem.index as number].selected = valueIn as boolean; 
                                    
                                    for (let lc = 0; lc < this.state.uploadPreview.procedures[rowItem.index as number].measurements.length; lc++) {
                                      const element = this.state.uploadPreview.procedures[rowItem.index as number].measurements[lc];
                                      //eslint-disable-next-line
                                      element.selected = valueIn as boolean;
                                    
                                  }
                                }
                                  this.forceUpdate();
                              
                            
                          }
                        }
                      /></label>

                      <div className="caseNumberUpload">
                        {rowItem.index +1}
                      </div>    

                      {
                        rowItem.existing ?
                        <div className="columnChildNote">Previously uploaded</div>
                        :<></>
                      }
                      </div>

                      }
                  },
                  {Name: "procedureDate", Caption: "Procedure Date",Type: "datetime",  isPrivate: true, additionalChildClass:  this.props.studySelected.allowPersonalData ? "unusedColumnChild" : "hiddenColumnChild"}, 
                  {Name: "patientId", Caption: "Patient Id", additionalChildClass: this.state.uploadPreview.includePatientId ? "" : (this.props.studySelected.allowPersonalData ? "unusedColumnChild" : "hiddenColumnChild")}, 
                  {Name: "name", Caption: "Patient Name",isPrivate: true, additionalChildClass:  this.props.studySelected.allowPersonalData ? "unusedColumnChild" : "hiddenColumnChild"},
                  {Name: "dateofbirth", Caption: "Date of birth",Type: "date",  isPrivate: true, additionalChildClass:  this.props.studySelected.allowPersonalData ? "unusedColumnChild" : "hiddenColumnChild"},
                  {Name: "anatomicalLocations", Caption: "Anatomical Locations", RenderTemplate:  this.renderListInGrid },
                  {Name: "createdDate", Caption:  "Surgery date", Type: this.state.uploadPreview.includeDateTime  ? "date" : "datenoday", additionalChildClass: this.state.uploadPreview.includeDateTime ? "" : "unusedColumnChild"}, 
                  {Name: "height", Caption: "Height", Type: "int", hidden: !this.state.uploadPreview.includeGenderHeightWeightAge}, 
                  {Name: "weight", Caption: "Weight", Type: "int", hidden: !this.state.uploadPreview.includeGenderHeightWeightAge}, 
                  {Name: "gender", Caption: "Gender", hidden: !this.state.uploadPreview.includeGenderHeightWeightAge}, 
                  {Name: "age", Caption: "Age", Type: "int", hidden: !this.state.uploadPreview.includeGenderHeightWeightAge}, 
                  {Name: "flowMeasurements", Caption: "Flow"},
                  {Name: "imagingMeasurements", Caption: "Imaging"},
                  {Name: "reports", Caption: "Reports"},
                  {Name: "comments", Caption: "Comments"},
                  {Name: "measurements", Caption: "Thumbnails", RenderTemplate: (item: PreviewMeasurement[], rowItem, parentRow) => {
                    let itemsOut = [];
                    let index = 0;
                    while (itemsOut.length < 4 && index < item.length)
                    { 
                      const element = item[index];
                      itemsOut.push(<MeasurmentThumbnail isExpandable={false} context="searchpreview" studySelected={this.props.studySelected} procedureId={rowItem.id} dataHelper={this.props.dataHelper} rowData={element as PreviewMeasurement} detailed={false} previewAvailable={false}  ></MeasurmentThumbnail>);
                      index++;
                    }
                    return <div className="thumbnails-container">{itemsOut} <span className="accordionArrow">&#9654;</span></div>;
                  }}
                  ]} rows={this.state.uploadPreview.procedures} privateRows={this.state.privateData} hasHierarchy={true} childrenpropertyname="measurements" childcolumns={[
                    {Name: "selected", Caption: "Selected", Type:"boolean", Editable: true, }, 
                    {Name: "index", Caption: "Name"}, 
                    {Name: "measurementType", Caption: "Type"}, 
                    {Name: "recordDate", Caption: "Date", Type: "date"}, 
                    {Name: "mean", Caption: "MF", RenderTemplate: this.renderMeanValueInGrid},
                    {Name: "pI", Caption: "PI", RenderTemplate: this.renderKeyValueInGrid},
                    {Name: "dF", Caption: "DF", RenderTemplate: this.renderKeyValueInGrid},
                    {Name: "anatomicalLocations", Caption: "Anatomical Locations", RenderTemplate:  this.renderSubwayMap},
                    {Name: "measurementType", Caption: "Thumbnail", RenderTemplate: (item: string, rowItem: DataGridRow, parentRow: any) => {

                      let itemsOut =[];

                      itemsOut.push(<MeasurmentThumbnail isExpandable={false} studySelected={this.props.studySelected} procedureId={parentRow.id} dataHelper={this.props.dataHelper} rowData={rowItem as PreviewMeasurement} detailed={false} previewAvailable={false}  ></MeasurmentThumbnail>);

                        // if (item === "Flow")
                        // {
                        //   itemsOut.push(<div className="imaging-thumbnail"><img alt="Flow" src="flowimage.png"/></div>)
                        // }
                        // else if (item === "Imaging")
                        // {
                        //   itemsOut.push(<div className="imaging-thumbnail"><img alt="Imaging" src="/usimage.png"/></div>)
                        // }
                      
                      return <div className="thumbnails-container">{itemsOut}</div>;
                    }},
                    {Name: "qualified", Caption: "Qualified", Type: "boolean"}
                    ]}  getChildGridRowAlternateColor={
                      (item:DataGridRow) => { 
                        return ((item as PreviewMeasurement)?.measurementSetIndex as number) % 2 === 0 }
                      }></DataGrid>
                    }
            </div>
           
          {/* <div>{
            this.state.uploadPreview.procedures.map((item: PreviewProcedureModel, index: number)=>
            {
                return <div>
                  <div>Procedure {index}</div>
                  <div >{item.createdDate}</div>
                  <div>{item.comments}</div>
                  <div>{item.anatomicalLocations}</div>
                  <div>{item.flowMeasurements}</div>
                  <div>{item.imagingMeasurements}</div>
                  <div></div>
                </div>
            })
          } </div> */}
          </div>
          : <></>
        }

        <div className="caseUploadFooter">
          
        {(this.state.status==="uploadReady"||this.state.status==="uploadClicked")?
        <button className="primaryButton actionButton uploadFilesButton" onClick={()=>
          {
              (this.fileBrowserMulti.current as MultiFileBrowser).openDialog();
              this.setState({status:"uploadClicked"});
  
          }}>Select files to upload</button>: <></>}

          {
            (this.state.status==="confirmClicked" &&  (this.state.uploadStatus ==="Processing" || this.state.uploadStatus ==="Completed"))?  <button className="primaryButton actionButton" onClick={()=>
              {
              
                this.markUploadingCompleted(null, true);
                this.props.closeClicked();
      
              }}>Done</button> : <></>
          }
        
        {
             (true || (this.state.previewReady && this.state.uploadPreview && this.state.uploadPreview.procedures && this.state.uploadPreview.procedures.filter((item)=> { return item.selected === true}).length > 0)) && this.state.status===("uploadClicked")
            ?
            <button className={"primaryButton actionButton uploadButton"} disabled={(this.state.previewReady && this.state.uploadPreview && this.state.uploadPreview.procedures && this.state.uploadPreview.procedures.filter((item)=> { return item.selected === true}).length > 0) ? false : true} onClick={()=>
              {
                let exportModel: PreviewExportModel;
                let selectedProcedureModels: PreviewProcedureModel[];
                let selectedMeasurementModels: PreviewMeasurement[];
                let progressMetadataIn: PreviewExportMetadataModel = {
                  studyId:"",
                  id: "",
                  procedures: []
                };

                for (let index = 0; index < this.state.uploadPreview.procedures.length; index++) {
                  const element = this.state.uploadPreview.procedures[index];
                  if (element.selected)
                  {
                      let procItem: PreviewProcedureMetadataModel ={
                        id: element.id,
                        index: element.index,
                        uploaded: 0,
                        processed: 0,
                        existing: false,
                        selected: element.selected,
                        measurements: []
                    };
                    progressMetadataIn.procedures.push(procItem)
                  }
                  
                }

                this.setState({status:"confirmClicked", progressMetadata: progressMetadataIn})



                this.uploadFiles("", (dataOut: string)=>{
                  exportModel = JSON.parse(dataOut);

                  selectedProcedureModels = this.getSelectedProcedures(exportModel);

                  selectedMeasurementModels = [];
                  let uploadProcs = this.state.progressMetadata;
                  selectedProcedureModels.forEach(item => { 

                    for (let index = 0; index < uploadProcs.procedures.length; index++) {
                      if (item.id === uploadProcs.procedures[index].id)
                        {
                          uploadProcs.procedures[index].processed =3;
                          uploadProcs.procedures[index].uploaded =3;
                        }
                    }

                    this.getSelectedMeasurements(item).forEach(selected => selectedMeasurementModels.push(selected));
                 
                 
                   

                  });
                  this.pwd = "";
                  //The upload is completed now.
                  this.props.refreshStudyRequested();
                  this.setState({uploadStatus: "Completed", uploadedData: [selectedProcedureModels.length,selectedMeasurementModels.length], progressMetadata: uploadProcs});
                  
                });
                ;
              
              
              }}>UPLOAD</button>
              
              : <></>
        } 
       </div>
        <InfoBox ref={this.infoBox} title="Confirmation" type="confirmation"></InfoBox> 
        <ErrorWindow ref={this.errorWindow}></ErrorWindow>

        <div className="uploadProgressbar">
        {/* {(this.state.uploadStatus ==="Uploading" || this.state.uploadStatus ==="Preparing") ?   
          <h4 className="doNotClose">Do not close this browser window until the files upload and data processing are finished.</h4>
          :
        <></>
        } */}
        {((this.state.initialUploadStatus && this.state.status==="confirmClicked" && this.state.fileProgress < this.state.totalFiles) ? <><div><Progressbar value={this.state.fileProgress} max={this.state.totalFiles} title={this.state.initialUploadStatus} showValues={false}></Progressbar></div></>: <></>)} 
          {/* {((this.state.progressText && this.state.status==="confirmClicked") ? <><div><Progressbar value={this.state.uploadLoaded} max={this.state.uploadTotal} title={""} showValues={false}></Progressbar></div></>: <></>)}  */}
        </div> 
        
      
        
      </>
    );
  }
}
